<svg
    *ngIf="name === 'ai'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
>
    <path
        d="M5.13054 11.1795C4.69007 11.5297 4.30943 11.9671 4.00065 12.4647C3.69187 11.9671 3.31123 11.5297 2.87076 11.1795C3.31123 10.8293 3.69187 10.3919 4.00065 9.89423C4.30944 10.3919 4.69007 10.8293 5.13054 11.1795ZM13.8057 8C12.4585 8.81363 11.3724 10.1241 10.6673 11.7028C9.96221 10.1241 8.87615 8.81363 7.52898 8C8.87615 7.18637 9.96221 5.87595 10.6673 4.29725C11.3724 5.87595 12.4585 7.18637 13.8057 8Z"
        stroke-width="1.8"
    />
</svg>
<svg
    *ngIf="name === 'save'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M17 21V13H7V21M7 3V8H15M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'tag'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M7 7H7.01M20.59 13.41L13.42 20.58C13.2343 20.766 13.0137 20.9135 12.7709 21.0141C12.5281 21.1148 12.2678 21.1666 12.005 21.1666C11.7422 21.1666 11.4819 21.1148 11.2391 21.0141C10.9963 20.9135 10.7757 20.766 10.59 20.58L2 12V2H12L20.59 10.59C20.9625 10.9647 21.1716 11.4716 21.1716 12C21.1716 12.5284 20.9625 13.0353 20.59 13.41Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'shield'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'award'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="24"
    viewBox="0 0 16 24"
    fill="none"
>
    <path
        d="M4.21 13.89L3 23L8 20L13 23L11.79 13.88M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'reload'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M1 4V10M1 10H7M1 10L5.64 5.64001C7.02091 4.26143 8.81245 3.36898 10.7447 3.09713C12.6769 2.82527 14.6451 3.18874 16.3528 4.13277C18.0605 5.0768 19.4152 6.55025 20.2126 8.33111C21.0101 10.112 21.2072 12.1038 20.7742 14.0064C20.3413 15.909 19.3017 17.6194 17.8121 18.8798C16.3226 20.1402 14.4637 20.8824 12.5157 20.9945C10.5677 21.1066 8.63598 20.5826 7.01166 19.5014C5.38734 18.4202 4.15839 16.8404 3.51 15"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'globe'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H2M12 22C6.47715 22 2 17.5228 2 12M12 22C14.5013 19.2616 15.9228 15.708 16 12C15.9228 8.29203 14.5013 4.73835 12 2M12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2M2 12C2 6.47715 6.47715 2 12 2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'share'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M7.15836 11.2583L12.85 14.575M12.8417 5.425L7.15836 8.74166M17.5 4.16666C17.5 5.54737 16.3807 6.66666 15 6.66666C13.6193 6.66666 12.5 5.54737 12.5 4.16666C12.5 2.78594 13.6193 1.66666 15 1.66666C16.3807 1.66666 17.5 2.78594 17.5 4.16666ZM7.5 9.99999C7.5 11.3807 6.38071 12.5 5 12.5C3.61929 12.5 2.5 11.3807 2.5 9.99999C2.5 8.61928 3.61929 7.49999 5 7.49999C6.38071 7.49999 7.5 8.61928 7.5 9.99999ZM17.5 15.8333C17.5 17.214 16.3807 18.3333 15 18.3333C13.6193 18.3333 12.5 17.214 12.5 15.8333C12.5 14.4526 13.6193 13.3333 15 13.3333C16.3807 13.3333 17.5 14.4526 17.5 15.8333Z"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="name === 'wrench'"
>
    <path
        d="M9.46641 4.20015C9.34426 4.32477 9.27584 4.49231 9.27584 4.66682C9.27584 4.84132 9.34426 5.00886 9.46641 5.13348L10.5331 6.20015C10.6577 6.3223 10.8252 6.39072 10.9997 6.39072C11.1742 6.39072 11.3418 6.3223 11.4664 6.20015L13.9797 3.68682C14.315 4.42761 14.4165 5.25297 14.2707 6.05291C14.125 6.85285 13.7389 7.58938 13.1639 8.16434C12.589 8.73929 11.8524 9.12537 11.0525 9.27112C10.2526 9.41687 9.4272 9.31537 8.68641 8.98015L4.07974 13.5868C3.81452 13.852 3.45481 14.001 3.07974 14.001C2.70467 14.001 2.34496 13.852 2.07974 13.5868C1.81452 13.3216 1.66553 12.9619 1.66553 12.5868C1.66553 12.2117 1.81452 11.852 2.07974 11.5868L6.68641 6.98015C6.35118 6.23936 6.24968 5.41399 6.39544 4.61405C6.54119 3.81411 6.92727 3.07759 7.50222 2.50263C8.07718 1.92767 8.8137 1.5416 9.61364 1.39584C10.4136 1.25009 11.2389 1.35159 11.9797 1.68682L9.46641 4.20015Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="name === 'locked'"
>
    <path
        d="M4.33366 7.33301V4.66634C4.33366 3.78229 4.68485 2.93444 5.30997 2.30932C5.93509 1.6842 6.78294 1.33301 7.66699 1.33301C8.55105 1.33301 9.39889 1.6842 10.024 2.30932C10.6491 2.93444 11.0003 3.78229 11.0003 4.66634V7.33301M3.00033 7.33301H12.3337C13.07 7.33301 13.667 7.92996 13.667 8.66634V13.333C13.667 14.0694 13.07 14.6663 12.3337 14.6663H3.00033C2.26395 14.6663 1.66699 14.0694 1.66699 13.333V8.66634C1.66699 7.92996 2.26395 7.33301 3.00033 7.33301Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="name === 'clock'"
>
    <path
        d="M7.66667 3.99967V7.99968L10.3333 9.33301M7.66667 1.33301C5.89856 1.33301 4.20286 2.03539 2.95262 3.28563C1.70238 4.53587 1 6.23157 1 7.99968C1 9.76779 1.70238 11.4635 2.95262 12.7137C4.20286 13.964 5.89856 14.6663 7.66667 14.6663C9.43478 14.6663 11.1305 13.964 12.3807 12.7137C13.631 11.4635 14.3333 9.76779 14.3333 7.99968C14.3333 6.23157 13.631 4.53587 12.3807 3.28563C11.1305 2.03539 9.43478 1.33301 7.66667 1.33301Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'key'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_13770_85926)">
        <g filter="url(#filter0_d_13770_85926)">
            <path
                d="M21.0003 2L19.0003 4M19.0003 4L22.0003 7L18.5003 10.5L15.5003 7.5M19.0003 4L15.5003 7.5M11.3903 11.61C11.9066 12.1195 12.3171 12.726 12.598 13.3948C12.879 14.0635 13.0249 14.7813 13.0273 15.5066C13.0297 16.232 12.8887 16.9507 12.6122 17.6213C12.3357 18.2919 11.9293 18.9012 11.4164 19.4141C10.9035 19.9271 10.2942 20.3334 9.62358 20.6099C8.95296 20.8864 8.23427 21.0275 7.50891 21.025C6.78354 21.0226 6.06582 20.8767 5.39707 20.5958C4.72831 20.3148 4.12174 19.9043 3.61227 19.388C2.6104 18.3507 2.05604 16.9614 2.06857 15.5193C2.0811 14.0772 2.65953 12.6977 3.67927 11.678C4.69902 10.6583 6.07849 10.0798 7.52057 10.0673C8.96265 10.0548 10.352 10.6091 11.3893 11.611L11.3903 11.61ZM11.3903 11.61L15.5003 7.5"
                stroke="#000D4D"
                stroke-opacity="0.45"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                shape-rendering="crispEdges"
            />
        </g>
    </g>
    <defs>
        <filter
            id="filter0_d_13770_85926"
            x="-2.93164"
            y="1"
            width="29.9321"
            height="29.0254"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13770_85926"
            />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_13770_85926"
                result="shape"
            />
        </filter>
        <clipPath id="clip0_13770_85926">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>

<svg
    *ngIf="name === 'web'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <g clip-path="url(#clip0_13213_221525)">
        <path
            d="M14.6663 8.0026C14.6663 11.6845 11.6816 14.6693 7.99967 14.6693M14.6663 8.0026C14.6663 4.32071 11.6816 1.33594 7.99967 1.33594M14.6663 8.0026H1.33301M7.99967 14.6693C4.31778 14.6693 1.33301 11.6845 1.33301 8.0026M7.99967 14.6693C9.66719 12.8437 10.6148 10.4746 10.6663 8.0026C10.6148 5.53063 9.66719 3.16151 7.99967 1.33594M7.99967 14.6693C6.33215 12.8437 5.38451 10.4746 5.33301 8.0026C5.38451 5.53063 6.33215 3.16151 7.99967 1.33594M1.33301 8.0026C1.33301 4.32071 4.31778 1.33594 7.99967 1.33594"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_13213_221525">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'octagon'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M15 9L9 15M9 9L15 15M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'copy'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
>
    <path
        d="M5 15.5H4C3.46957 15.5 2.96086 15.2893 2.58579 14.9142C2.21071 14.5391 2 14.0304 2 13.5V4.5C2 3.96957 2.21071 3.46086 2.58579 3.08579C2.96086 2.71071 3.46957 2.5 4 2.5H13C13.5304 2.5 14.0391 2.71071 14.4142 3.08579C14.7893 3.46086 15 3.96957 15 4.5V5.5M11 9.5H20C21.1046 9.5 22 10.3954 22 11.5V20.5C22 21.6046 21.1046 22.5 20 22.5H11C9.89543 22.5 9 21.6046 9 20.5V11.5C9 10.3954 9.89543 9.5 11 9.5Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'bell'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'pause'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M10 4H6V20H10V4Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M18 4H14V20H18V4Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'upload'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
>
    <path
        d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'history-foreward'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M22.9999 4V10M22.9999 10H16.9999M22.9999 10L18.3699 5.64001C16.9905 4.25975 15.1999 3.3652 13.2678 3.09116C11.3358 2.81711 9.36705 3.17843 7.65823 4.12065C5.94942 5.06288 4.59313 6.53496 3.79374 8.31508C2.99436 10.0952 2.79519 12.0869 3.22625 13.9901C3.6573 15.8932 4.69524 17.6047 6.18363 18.8667C7.67203 20.1286 9.53026 20.8726 11.4783 20.9866C13.4263 21.1006 15.3586 20.5783 16.984 19.4985C18.6094 18.4187 19.8399 16.8399 20.4899 15"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'history-back'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M1 4V10M1 10H7M1 10L5.64 5.64001C7.02091 4.26143 8.81245 3.36898 10.7447 3.09713C12.6769 2.82527 14.6451 3.18874 16.3528 4.13277C18.0605 5.0768 19.4152 6.55025 20.2126 8.33111C21.0101 10.112 21.2072 12.1038 20.7742 14.0064C20.3413 15.909 19.3017 17.6194 17.8121 18.8798C16.3226 20.1402 14.4637 20.8824 12.5157 20.9945C10.5677 21.1066 8.63598 20.5826 7.01166 19.5014C5.38734 18.4202 4.15839 16.8404 3.51 15"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'download'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M7 10L12 15M12 15L17 10M12 15L12 3M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'eye-off'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <g clip-path="url(#clip0_10550_92052)">
        <path
            d="M9.9 4.24003C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003L17.94 17.94Z"
            stroke-opacity="0.45"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10550_92052">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'home'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M21.4142 10.4142L13.4142 2.41421C12.6332 1.63317 11.3668 1.63316 10.5858 2.41421L2.58579 10.4142C2.21071 10.7893 2 11.298 2 11.8284V20C2 21.1046 2.89543 22 4 22H7C8.10457 22 9 21.1046 9 20V15C9 13.8954 9.89543 13 11 13H13C14.1046 13 15 13.8954 15 15V20C15 21.1046 15.8954 22 17 22H20C21.1046 22 22 21.1046 22 20V11.8284C22 11.298 21.7893 10.7893 21.4142 10.4142Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'help'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'flag'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    width="800px"
    height="800px"
    viewBox="-4 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="name === 'pdf'"
>
    <path
        d="M25.6686 26.0962C25.1812 26.2401 24.4656 26.2563 23.6984 26.145C22.875 26.0256 22.0351 25.7739 21.2096 25.403C22.6817 25.1888 23.8237 25.2548 24.8005 25.6009C25.0319 25.6829 25.412 25.9021 25.6686 26.0962ZM17.4552 24.7459C17.3953 24.7622 17.3363 24.7776 17.2776 24.7939C16.8815 24.9017 16.4961 25.0069 16.1247 25.1005L15.6239 25.2275C14.6165 25.4824 13.5865 25.7428 12.5692 26.0529C12.9558 25.1206 13.315 24.178 13.6667 23.2564C13.9271 22.5742 14.193 21.8773 14.468 21.1894C14.6075 21.4198 14.7531 21.6503 14.9046 21.8814C15.5948 22.9326 16.4624 23.9045 17.4552 24.7459ZM14.8927 14.2326C14.958 15.383 14.7098 16.4897 14.3457 17.5514C13.8972 16.2386 13.6882 14.7889 14.2489 13.6185C14.3927 13.3185 14.5105 13.1581 14.5869 13.0744C14.7049 13.2566 14.8601 13.6642 14.8927 14.2326ZM9.63347 28.8054C9.38148 29.2562 9.12426 29.6782 8.86063 30.0767C8.22442 31.0355 7.18393 32.0621 6.64941 32.0621C6.59681 32.0621 6.53316 32.0536 6.44015 31.9554C6.38028 31.8926 6.37069 31.8476 6.37359 31.7862C6.39161 31.4337 6.85867 30.8059 7.53527 30.2238C8.14939 29.6957 8.84352 29.2262 9.63347 28.8054ZM27.3706 26.1461C27.2889 24.9719 25.3123 24.2186 25.2928 24.2116C24.5287 23.9407 23.6986 23.8091 22.7552 23.8091C21.7453 23.8091 20.6565 23.9552 19.2582 24.2819C18.014 23.3999 16.9392 22.2957 16.1362 21.0733C15.7816 20.5332 15.4628 19.9941 15.1849 19.4675C15.8633 17.8454 16.4742 16.1013 16.3632 14.1479C16.2737 12.5816 15.5674 11.5295 14.6069 11.5295C13.948 11.5295 13.3807 12.0175 12.9194 12.9813C12.0965 14.6987 12.3128 16.8962 13.562 19.5184C13.1121 20.5751 12.6941 21.6706 12.2895 22.7311C11.7861 24.0498 11.2674 25.4103 10.6828 26.7045C9.04334 27.3532 7.69648 28.1399 6.57402 29.1057C5.8387 29.7373 4.95223 30.7028 4.90163 31.7107C4.87693 32.1854 5.03969 32.6207 5.37044 32.9695C5.72183 33.3398 6.16329 33.5348 6.6487 33.5354C8.25189 33.5354 9.79489 31.3327 10.0876 30.8909C10.6767 30.0029 11.2281 29.0124 11.7684 27.8699C13.1292 27.3781 14.5794 27.011 15.985 26.6562L16.4884 26.5283C16.8668 26.4321 17.2601 26.3257 17.6635 26.2153C18.0904 26.0999 18.5296 25.9802 18.976 25.8665C20.4193 26.7844 21.9714 27.3831 23.4851 27.6028C24.7601 27.7883 25.8924 27.6807 26.6589 27.2811C27.3486 26.9219 27.3866 26.3676 27.3706 26.1461ZM30.4755 36.2428C30.4755 38.3932 28.5802 38.5258 28.1978 38.5301H3.74486C1.60224 38.5301 1.47322 36.6218 1.46913 36.2428L1.46884 3.75642C1.46884 1.6039 3.36763 1.4734 3.74457 1.46908H20.263L20.2718 1.4778V7.92396C20.2718 9.21763 21.0539 11.6669 24.0158 11.6669H30.4203L30.4753 11.7218L30.4755 36.2428ZM28.9572 10.1976H24.0169C21.8749 10.1976 21.7453 8.29969 21.7424 7.92417V2.95307L28.9572 10.1976ZM31.9447 36.2428V11.1157L21.7424 0.871022V0.823357H21.6936L20.8742 0H3.74491C2.44954 0 0 0.785336 0 3.75711V36.2435C0 37.5427 0.782956 40 3.74491 40H28.2001C29.4952 39.9997 31.9447 39.2143 31.9447 36.2428Z"
        fill="#EB5757"
    />
</svg>
<svg
    *ngIf="name === 'expand'"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M15.5 10.8333V15.8333C15.5 16.2754 15.3244 16.6993 15.0118 17.0118C14.6993 17.3244 14.2754 17.5 13.8333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V6.66667C3 6.22464 3.17559 5.80072 3.48816 5.48816C3.80072 5.17559 4.22464 5 4.66667 5H9.66667M13 2.5H18M18 2.5V7.5M18 2.5L8.83333 11.6667"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'miro'"
    version="1.1"
    id="Layer_1"
    xmlns:x="ns_extend;"
    xmlns:i="ns_ai;"
    xmlns:graph="ns_graphs;"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 48 48"
    style="enable-background: new 0 0 48 48"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #ffd02f;
        }
        .st1 {
            fill-rule: evenodd;
            clip-rule: evenodd;
            fill: #050038;
        }
    </style>

    <g>
        <path
            class="st0"
            d="M10.4,0h27.2C43.3,0,48,4.7,48,10.4v27.2C48,43.3,43.3,48,37.6,48H10.4C4.7,48,0,43.3,0,37.6V10.4
     C0,4.7,4.7,0,10.4,0z"
        ></path>
        <path
            class="st1"
            d="M33.3,6h-5.3l4.4,7.7L22.8,6h-5.3l4.8,9.4L12.3,6H7l5.3,12L7,42h5.3l10.1-25.7L17.5,42h5.3l9.7-27.4L28.1,42
     h5.3L43,12L33.3,6z"
        ></path>
    </g>
</svg>
<svg
    *ngIf="name === 'presentation'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <g clip-path="url(#clip0_10644_89552)">
        <path
            d="M4.66699 14.666L8.00033 11.3327L11.3337 14.666M13.3337 11.3327H2.66699C1.93061 11.3327 1.33366 10.7357 1.33366 9.99935V2.66602C1.33366 1.92964 1.93061 1.33268 2.66699 1.33268H13.3337C14.07 1.33268 14.667 1.92964 14.667 2.66602V9.99935C14.667 10.7357 14.07 11.3327 13.3337 11.3327Z"
            stroke-opacity="0.8"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10644_89552">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'film'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <g clip-path="url(#clip0_10644_89564)">
        <path
            d="M4.66634 1.33398V14.6673M11.333 1.33398V14.6673M1.33301 8.00065H14.6663M1.33301 4.66732H4.66634M1.33301 11.334H4.66634M11.333 11.334H14.6663M11.333 4.66732H14.6663M2.78634 1.33398H13.213C14.0157 1.33398 14.6663 1.98466 14.6663 2.78732V13.214C14.6663 14.0166 14.0157 14.6673 13.213 14.6673H2.78634C1.98369 14.6673 1.33301 14.0166 1.33301 13.214V2.78732C1.33301 1.98466 1.98369 1.33398 2.78634 1.33398Z"
            stroke-opacity="0.8"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10644_89564">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'launch'"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
>
    <path
        d="M4.57709 9.05667C4.3416 9.29188 4.23857 9.62883 4.30224 9.95551C4.36592 10.2822 4.58795 10.5558 4.89453 10.6853L7.03452 11.5896C7.52027 11.7949 8.08193 11.5877 8.31799 11.1161C8.56553 10.6217 8.82134 10.1459 9.08534 9.6889C9.34527 9.23889 9.63224 8.78706 9.94667 8.33342C10.1389 8.05607 10.1783 7.70046 10.0514 7.38775C9.92452 7.07505 9.64847 6.84744 9.31732 6.78246L7.78091 6.48103C7.45429 6.41695 7.1172 6.51958 6.8817 6.75479L4.57709 9.05667ZM8.24532 11.6823C8.1042 12.0523 8.1947 12.4707 8.4761 12.7493L11.6038 15.8459C11.8824 16.1217 12.2965 16.2093 12.663 16.0699C13.5236 15.7424 14.4173 15.2522 15.3427 14.6168C16.2719 13.9787 17.1419 13.2544 17.9525 12.4448C19.3119 11.087 20.3832 9.57025 21.1577 7.89583C21.9299 6.22622 22.3003 4.6176 22.1942 3.09064C22.1596 2.59296 21.7635 2.19692 21.2658 2.1624C19.738 2.05643 18.124 2.42611 16.4447 3.1965C14.7591 3.96978 13.2354 5.03983 11.875 6.39855C11.0645 7.20816 10.3392 8.07717 9.7003 9.00539C9.06411 9.92965 8.57325 10.8225 8.24532 11.6823ZM13.662 19.4398C13.7906 19.7472 14.0639 19.9704 14.3908 20.035C14.7178 20.0995 15.0554 19.997 15.2912 19.7614L17.5958 17.4596C17.8317 17.2239 17.9347 16.8862 17.8704 16.5591L17.5686 15.0245C17.5035 14.6936 17.2761 14.4179 16.9637 14.291C16.6513 14.1641 16.2959 14.2032 16.0186 14.395C15.568 14.7066 15.1198 14.9862 14.6741 15.2345C14.2123 15.4917 13.7317 15.745 13.2324 15.9944C12.7615 16.2296 12.5535 16.7894 12.7566 17.2749L13.662 19.4398ZM14.183 21.1381L12.4589 17.0993C12.4086 16.9817 12.3363 16.8748 12.2458 16.7844L7.5543 12.0984C7.46389 12.0081 7.35702 11.936 7.23945 11.8859L3.19333 10.1627L6.73123 6.60786C6.73153 6.60756 6.73183 6.60726 6.73213 6.60696C6.86902 6.47051 7.03201 6.37127 7.23741 6.30814C7.43521 6.24735 7.62791 6.23755 7.83063 6.27792C7.83091 6.27797 7.83119 6.27803 7.83147 6.27808L10.5457 6.82577C10.8739 6.89198 11.2134 6.78961 11.4502 6.55305C13.2723 4.73311 15.1494 3.47927 17.0771 2.75303C18.7667 2.11646 20.4965 1.88352 22.2779 2.05405C22.4495 3.83493 22.2204 5.56802 21.5898 7.2647C20.8718 9.1968 19.622 11.0744 17.8012 12.8931C17.5639 13.1301 17.4612 13.4702 17.5277 13.7989L18.076 16.5099C18.0761 16.5102 18.0762 16.5105 18.0762 16.5109C18.1168 16.7144 18.1057 16.8989 18.0482 17.0809L19.0017 17.3823L18.0482 17.0809C17.9866 17.2757 17.888 17.4376 17.7463 17.5791L14.183 21.1381ZM3.03254 20.1404C2.9861 20.4535 3.09068 20.7702 3.31449 20.9941C3.53831 21.218 3.85493 21.3226 4.1681 21.2763C4.72894 21.1933 5.28203 21.0536 5.82665 20.8586L5.48954 19.9171L5.82665 20.8586C6.33922 20.6751 6.85055 20.437 7.19764 20.0903C7.59109 19.6973 7.81323 19.2013 7.84589 18.6469C7.88093 18.0519 7.67492 17.5078 7.25251 17.0858C6.8377 16.6715 6.30598 16.4615 5.72082 16.4787C5.15593 16.4953 4.64821 16.7134 4.24785 17.1132C3.90667 17.454 3.66313 17.9574 3.47036 18.4676C3.26318 19.016 3.11657 19.5739 3.03254 20.1404ZM14.7699 9.54993C14.5431 9.32338 14.4322 9.06446 14.4322 8.70917C14.4322 8.35388 14.5431 8.09496 14.7699 7.86841C14.9937 7.64487 15.2567 7.53061 15.6271 7.53061C15.9975 7.53061 16.2604 7.64487 16.4843 7.86841C16.7111 8.09496 16.822 8.35388 16.822 8.70917C16.822 9.06446 16.7111 9.32338 16.4843 9.54993C16.2604 9.77347 15.9975 9.88773 15.6271 9.88773C15.2567 9.88773 14.9937 9.77347 14.7699 9.54993ZM4.09738 16.9937C4.5482 16.5434 5.07814 16.3199 5.74635 16.3133C6.40791 16.3068 6.92972 16.521 7.37554 16.9663C7.82131 17.4116 8.03536 17.9322 8.02882 18.5919C8.02221 19.2582 7.79887 19.787 7.34811 20.2372C7.06206 20.5229 6.48312 20.8559 5.47013 21.1672C4.72628 21.3958 3.74675 21.6121 2.52111 21.8123C2.72152 20.589 2.93791 19.6113 3.16664 18.8688C3.47823 17.8573 3.81145 17.2793 4.09738 16.9937Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'user-check'"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
>
    <g clip-path="url(#clip0_12092_97335)">
        <path
            d="M16.6665 21V19C16.6665 17.9391 16.2451 16.9217 15.4949 16.1716C14.7448 15.4214 13.7274 15 12.6665 15H5.6665C4.60564 15 3.58822 15.4214 2.83808 16.1716C2.08793 16.9217 1.6665 17.9391 1.6665 19V21M17.6665 11L19.6665 13L23.6665 9M13.1665 7C13.1665 9.20914 11.3756 11 9.1665 11C6.95736 11 5.1665 9.20914 5.1665 7C5.1665 4.79086 6.95736 3 9.1665 3C11.3756 3 13.1665 4.79086 13.1665 7Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_12092_97335">
            <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.666504)"
            />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'userplus'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M20 8V14M23 11H17M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'eye'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'component'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <g clip-path="url(#clip0_10252_56162)">
        <path
            d="M14.5185 7.1865L8.81482 1.48278C8.36481 1.03277 7.63519 1.03277 7.18518 1.48278L1.48147 7.1865C1.03146 7.63651 1.03146 8.36612 1.48147 8.81613L7.18518 14.5198C7.63519 14.9698 8.36481 14.9698 8.81482 14.5198L14.5185 8.81613C14.9685 8.36612 14.9685 7.63651 14.5185 7.1865Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10252_56162">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'arrow-right'"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
>
    <path
        d="M3.83398 7.9987H13.1673M13.1673 7.9987L8.50065 3.33203M13.1673 7.9987L8.50065 12.6654"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'arrow-left'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
>
    <path
        d="M15.8327 9.99935H4.16602M4.16602 9.99935L9.99935 15.8327M4.16602 9.99935L9.99935 4.16602"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'search'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <path
        d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'filter'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <path
        d="M14.6673 2H1.33398L6.66732 8.30667V12.6667L9.33398 14V8.30667L14.6673 2Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'arrow-down'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <path
        d="M10.666 10.2956L7.99935 12.666M7.99935 12.666L5.33268 10.2956M7.99935 12.666L7.99935 3.33268"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'chevron-up'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M18 15L12 9L6 15"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'chevron-down'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M6 9L12 15L18 9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'mic'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M19 10V12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19M12 19C10.1435 19 8.36301 18.2625 7.05025 16.9497C5.7375 15.637 5 13.8565 5 12V10M12 19V23M8 23H16M12 1C11.2044 1 10.4413 1.31607 9.87868 1.87868C9.31607 2.44129 9 3.20435 9 4V12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'wind'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M9.59 4.58998C9.82231 4.3563 10.1088 4.18363 10.4239 4.08732C10.739 3.99102 11.073 3.97407 11.3963 4.03797C11.7195 4.10188 12.022 4.24466 12.2768 4.45363C12.5315 4.66259 12.7307 4.93127 12.8566 5.23578C12.9825 5.54028 13.0313 5.87117 12.9985 6.19905C12.9657 6.52692 12.8524 6.84161 12.6687 7.11514C12.4849 7.38868 12.2365 7.61258 11.9454 7.76695C11.6542 7.92132 11.3295 8.00137 11 7.99998H2M12.59 19.41C12.8223 19.6437 13.1088 19.8163 13.4239 19.9126C13.739 20.0089 14.073 20.0259 14.3963 19.962C14.7195 19.8981 15.022 19.7553 15.2768 19.5463C15.5315 19.3374 15.7307 19.0687 15.8566 18.7642C15.9825 18.4597 16.0313 18.1288 15.9985 17.8009C15.9657 17.473 15.8524 17.1584 15.6687 16.8848C15.4849 16.6113 15.2365 16.3874 14.9454 16.233C14.6542 16.0786 14.3295 15.9986 14 16H2M17.73 7.72998C18.0208 7.43987 18.3787 7.2259 18.7719 7.10699C19.1652 6.98809 19.5816 6.96792 19.9845 7.04827C20.3874 7.12861 20.7642 7.307 21.0817 7.56765C21.3993 7.8283 21.6477 8.16318 21.805 8.54267C21.9623 8.92217 22.0236 9.33458 21.9836 9.74343C21.9436 10.1523 21.8035 10.545 21.5756 10.8868C21.3477 11.2286 21.0391 11.509 20.6771 11.7031C20.3151 11.8973 19.9108 11.9992 19.5 12H2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'edit2'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M11 4.00023H4C3.46957 4.00023 2.96086 4.21094 2.58579 4.58601C2.21071 4.96109 2 5.46979 2 6.00023V20.0002C2 20.5307 2.21071 21.0394 2.58579 21.4144C2.96086 21.7895 3.46957 22.0002 4 22.0002H18C18.5304 22.0002 19.0391 21.7895 19.4142 21.4144C19.7893 21.0394 20 20.5307 20 20.0002V13.0002M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'edit'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M17 3.0003C17.2626 2.73766 17.5744 2.52932 17.9176 2.38718C18.2608 2.24503 18.6286 2.17188 19 2.17188C19.3714 2.17187 19.7392 2.24503 20.0824 2.38718C20.4256 2.52932 20.7374 2.73766 21 3.0003C21.2626 3.26295 21.471 3.57475 21.6131 3.91791C21.7553 4.26107 21.8284 4.62887 21.8284 5.0003C21.8284 5.37174 21.7553 5.73953 21.6131 6.08269C21.471 6.42585 21.2626 6.73766 21 7.0003L7.5 20.5003L2 22.0003L3.5 16.5003L17 3.0003Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'more-vertical'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'more'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M19 11C18.7348 11 18.4804 11.1054 18.2929 11.2929C18.1054 11.4804 18 11.7348 18 12C18 12.2652 18.1054 12.5196 18.2929 12.7071C18.4804 12.8946 18.7348 13 19 13C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M5 11C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13C5.26522 13 5.51957 12.8946 5.70711 12.7071C5.89464 12.5196 6 12.2652 6 12C6 11.7348 5.89464 11.4804 5.70711 11.2929C5.51957 11.1054 5.26522 11 5 11Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'layout'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M3 9H21M9 21V9M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
        stroke="#4C64D9"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'alert'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M11.9988 8.99927V12.9993M11.9988 16.9993H12.0088M10.2888 3.85923L1.8188 17.9992C1.64417 18.3017 1.55177 18.6445 1.55079 18.9937C1.54981 19.343 1.64029 19.6864 1.81323 19.9898C1.98616 20.2931 2.23553 20.546 2.53651 20.7231C2.83749 20.9002 3.1796 20.9954 3.5288 20.9992H20.4688C20.818 20.9954 21.1601 20.9002 21.4611 20.7231C21.7621 20.546 22.0114 20.2931 22.1844 19.9898C22.3573 19.6864 22.4478 19.343 22.4468 18.9937C22.4458 18.6445 22.3534 18.3017 22.1788 17.9992L13.7088 3.85923C13.5305 3.56533 13.2795 3.32235 12.98 3.15371C12.6805 2.98508 12.3425 2.89648 11.9988 2.89648C11.6551 2.89648 11.3171 2.98508 11.0176 3.15371C10.7181 3.32235 10.4671 3.56533 10.2888 3.85923Z"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'trash'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'user'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'users'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21.0009V19.0009C22.9993 18.1146 22.7044 17.2536 22.1614 16.5532C21.6184 15.8527 20.8581 15.3524 20 15.1309M16 3.13086C16.8604 3.35116 17.623 3.85156 18.1676 4.55317C18.7122 5.25478 19.0078 6.11769 19.0078 7.00586C19.0078 7.89403 18.7122 8.75694 18.1676 9.45855C17.623 10.1602 16.8604 10.6606 16 10.8809M9 3C7.93913 3 6.92172 3.42143 6.17157 4.17157C5.42143 4.92172 5 5.93913 5 7C5 8.06087 5.42143 9.07828 6.17157 9.82843C6.92172 10.5786 7.93913 11 9 11C10.0609 11 11.0783 10.5786 11.8284 9.82843C12.5786 9.07828 13 8.06087 13 7C13 5.93913 12.5786 4.92172 11.8284 4.17157C11.0783 3.42143 10.0609 3 9 3Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'email'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'trending-down'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_14397_9328)">
        <path
            d="M19.1663 15L11.2497 7.08333L7.08301 11.25L0.833008 5M19.1663 15H14.1663M19.1663 15V10"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_14397_9328">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'trending-up'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_14397_9283)">
        <path
            d="M19.1663 5L11.2497 12.9167L7.08301 8.75L0.833008 15M19.1663 5H14.1663M19.1663 5V10"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_14397_9283">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'star'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M10.0003 1.66675L12.5753 6.88341L18.3337 7.72508L14.167 11.7834L15.1503 17.5167L10.0003 14.8084L4.85033 17.5167L5.83366 11.7834L1.66699 7.72508L7.42533 6.88341L10.0003 1.66675Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'list'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'logout'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'english'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
>
    <mask
        id="mask0_10774_85418"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="18"
    >
        <path d="M24.001 0H0.000307083V17.9993H24.001V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_10774_85418)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.001 0V17.9993H0.000307083V0H24.001Z"
            fill="#2E42A5"
        />
        <mask
            id="mask1_10774_85418"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="-1"
            width="25"
            height="19"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24.001 -0.00195312V17.9973H0.000307083V-0.00195312H24.001Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask1_10774_85418)">
            <mask
                id="mask2_10774_85418"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="-1"
                width="25"
                height="19"
            >
                <path
                    d="M24.001 -0.00390625H0.000307083V17.9954H24.001V-0.00390625Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask2_10774_85418)">
                <path
                    d="M26.6748 16.7099L21.3934 18.9434L-0.118139 2.42484L-2.90394 -0.894136L2.74371 -1.64062L11.5178 5.47769L18.58 10.2738L26.6748 16.7099Z"
                    fill="white"
                />
                <path
                    d="M25.9521 18.2761L23.2615 19.5722L-1.90321 -1.20117H1.87472L25.9521 18.2761Z"
                    fill="#F50100"
                />
                <path
                    d="M-2.67154 16.7099L2.60989 18.9434L24.1214 2.42484L26.9072 -0.894136L21.2595 -1.64062L12.4855 5.47769L5.42329 10.2738L-2.67154 16.7099Z"
                    fill="white"
                />
                <path
                    d="M-2.49086 17.831L0.199768 19.1271L10.9152 10.233L14.0921 9.23919L27.1758 -0.884766H23.3978L10.3215 8.9989L6.8481 10.1905L-2.49086 17.831Z"
                    fill="#F50100"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.16832 -1.50195H14.8351V5.99774H25.4814V11.9975H14.8351V19.4972H9.16832V11.9975H-1.51933V5.99774H9.16832V-1.50195Z"
                    fill="#F50100"
                />
                <mask
                    id="mask3_10774_85418"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="-2"
                    y="-2"
                    width="28"
                    height="22"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.17027 -1.50195H14.8371V5.99774H25.4834V11.9975H14.8371V19.4972H9.17027V11.9975H-1.51738V5.99774H9.17027V-1.50195Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask3_10774_85418)">
                    <path
                        d="M14.836 -1.50201V-3.00195H16.3361V-1.50201H14.836ZM9.16925 -1.50201H7.66921V-3.00195H9.16925V-1.50201ZM14.836 5.99768V7.49762H13.336V5.99768H14.836ZM25.4824 5.99768V4.49774H26.9824V5.99768H25.4824ZM25.4824 11.9974H26.9824V13.4974H25.4824V11.9974ZM14.836 11.9974H13.336V10.4975H14.836V11.9974ZM14.836 19.4971H16.3361V20.9971H14.836V19.4971ZM9.16925 19.4971V20.9971H7.66921V19.4971H9.16925ZM9.16925 11.9974V10.4975H10.6693V11.9974H9.16925ZM-1.5184 11.9974V13.4974H-3.01844V11.9974H-1.5184ZM-1.5184 5.99768H-3.01844V4.49774H-1.5184V5.99768ZM9.16925 5.99768H10.6693V7.49762H9.16925V5.99768ZM14.836 -0.00207543H9.16925V-3.00195H14.836V-0.00207543ZM13.336 5.99768V-1.50201H16.3361V5.99768H13.336ZM25.4824 7.49762H14.836V4.49774H25.4824V7.49762ZM23.9823 11.9974V5.99768H26.9824V11.9974H23.9823ZM14.836 10.4975H25.4824V13.4974H14.836V10.4975ZM13.336 19.4971V11.9974H16.3361V19.4971H13.336ZM9.16925 17.9972H14.836V20.9971H9.16925V17.9972ZM10.6693 11.9974V19.4971H7.66921V11.9974H10.6693ZM-1.5184 10.4975H9.16925V13.4974H-1.5184V10.4975ZM-0.0183582 5.99768V11.9974H-3.01844V5.99768H-0.0183582ZM9.16925 7.49762H-1.5184V4.49774H9.16925V7.49762ZM10.6693 -1.50201V5.99768H7.66921V-1.50201H10.6693Z"
                        fill="white"
                    />
                </g>
            </g>
        </g>
    </g>
</svg>
<svg
    *ngIf="name === 'german'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
>
    <mask
        id="mask0_10576_87624"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="24"
        height="19"
    >
        <path d="M0 -0.00195312H24V17.998H0V-0.00195312Z" fill="white" />
    </mask>
    <g mask="url(#mask0_10576_87624)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 11.998H24V17.998H0V11.998Z"
            fill="#FFD018"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 5.99805H24V11.998H0V5.99805Z"
            fill="#E31D1C"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 -0.00195312H24V5.99805H0V-0.00195312Z"
            fill="#272727"
        />
    </g>
</svg>
<svg
    *ngIf="name === 'heart'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M20.8401 4.60987C20.3294 4.09888 19.7229 3.69352 19.0555 3.41696C18.388 3.14039 17.6726 2.99805 16.9501 2.99805C16.2276 2.99805 15.5122 3.14039 14.8448 3.41696C14.1773 3.69352 13.5709 4.09888 13.0601 4.60987L12.0001 5.66987L10.9401 4.60987C9.90843 3.57818 8.50915 2.99858 7.05012 2.99858C5.59109 2.99858 4.19181 3.57818 3.16012 4.60987C2.12843 5.64156 1.54883 7.04084 1.54883 8.49987C1.54883 9.95891 2.12843 11.3582 3.16012 12.3899L12.0001 21.2299L20.8401 12.3899C21.3511 11.8791 21.7565 11.2727 22.033 10.6052C22.3096 9.93777 22.4519 9.22236 22.4519 8.49987C22.4519 7.77738 22.3096 7.06198 22.033 6.39452C21.7565 5.72706 21.3511 5.12063 20.8401 4.60987Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'file'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9M13 2L20 9M13 2V9H20"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'close'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M18 6L6 18M6 6L18 18"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'error'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M15 9L9 15M9 9L15 15M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'settings'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <g clip-path="url(#clip0_10252_83590)">
        <path
            d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10252_83590">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'box'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
>
    <g clip-path="url(#clip0_10252_48669)">
        <path
            d="M2.18001 5.16272L8.00001 8.52939L13.82 5.16272M8 15.2427V8.52271M14 11.1894V5.85605C13.9998 5.62224 13.938 5.39259 13.821 5.19016C13.704 4.98773 13.5358 4.81963 13.3333 4.70272L8.66667 2.03605C8.46397 1.91903 8.23405 1.85742 8 1.85742C7.76595 1.85742 7.53603 1.91903 7.33333 2.03605L2.66667 4.70272C2.46418 4.81963 2.29599 4.98773 2.17897 5.19016C2.06196 5.39259 2.00024 5.62224 2 5.85605V11.1894C2.00024 11.4232 2.06196 11.6528 2.17897 11.8553C2.29599 12.0577 2.46418 12.2258 2.66667 12.3427L7.33333 15.0094C7.53603 15.1264 7.76595 15.188 8 15.188C8.23405 15.188 8.46397 15.1264 8.66667 15.0094L13.3333 12.3427C13.5358 12.2258 13.704 12.0577 13.821 11.8553C13.938 11.6528 13.9998 11.4232 14 11.1894Z"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_10252_48669">
            <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.523438)"
            />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'car'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
>
    <g clip-path="url(#clip0_11059_72653)">
        <path
            d="M0.833496 0.833252H4.16683L6.40016 11.9916C6.47637 12.3752 6.68509 12.7199 6.98978 12.9652C7.29448 13.2104 7.67574 13.3407 8.06683 13.3333H16.1668C16.5579 13.3407 16.9392 13.2104 17.2439 12.9652C17.5486 12.7199 17.7573 12.3752 17.8335 11.9916L19.1668 4.99992H5.00016M8.3335 17.4999C8.3335 17.9602 7.9604 18.3333 7.50016 18.3333C7.03992 18.3333 6.66683 17.9602 6.66683 17.4999C6.66683 17.0397 7.03992 16.6666 7.50016 16.6666C7.9604 16.6666 8.3335 17.0397 8.3335 17.4999ZM17.5002 17.4999C17.5002 17.9602 17.1271 18.3333 16.6668 18.3333C16.2066 18.3333 15.8335 17.9602 15.8335 17.4999C15.8335 17.0397 16.2066 16.6666 16.6668 16.6666C17.1271 16.6666 17.5002 17.0397 17.5002 17.4999Z"
            stroke="#4C64D9"
            stroke-opacity="0.8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_11059_72653">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'cpu'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
>
    <g clip-path="url(#clip0_11059_27479)">
        <path
            d="M5.99984 0.666748V2.66675M9.99984 0.666748V2.66675M5.99984 13.3334V15.3334M9.99984 13.3334V15.3334M13.3332 6.00008H15.3332M13.3332 9.33341H15.3332M0.666504 6.00008H2.6665M0.666504 9.33341H2.6665M3.99984 2.66675H11.9998C12.7362 2.66675 13.3332 3.2637 13.3332 4.00008V12.0001C13.3332 12.7365 12.7362 13.3334 11.9998 13.3334H3.99984C3.26346 13.3334 2.6665 12.7365 2.6665 12.0001V4.00008C2.6665 3.2637 3.26346 2.66675 3.99984 2.66675ZM5.99984 6.00008H9.99984V10.0001H5.99984V6.00008Z"
            stroke="#000D4D"
            stroke-opacity="0.45"
            stroke-width="1.875"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_11059_27479">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'refresh'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
>
    <g clip-path="url(#clip0_11059_27375)">
        <path
            d="M19.1668 3.3333V8.3333M19.1668 8.3333H14.1668M19.1668 8.3333L15.3002 4.69998C14.4045 3.80391 13.2965 3.14932 12.0795 2.79729C10.8625 2.44527 9.57608 2.40727 8.3404 2.68686C7.10472 2.96645 5.96 3.55451 5.01305 4.39616C4.06611 5.23782 3.3478 6.30564 2.92516 7.49998M0.833496 16.6666V11.6666M0.833496 11.6666H5.8335M0.833496 11.6666L4.70016 15.3C5.59578 16.1961 6.70381 16.8506 7.92084 17.2027C9.13787 17.5547 10.4242 17.5927 11.6599 17.3131C12.8956 17.0335 14.0403 16.4455 14.9873 15.6038C15.9342 14.7621 16.6525 13.6943 17.0752 12.5"
            stroke="#4C64D9"
            stroke-opacity="0.8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_11059_27375">
            <rect width="20" height="20" fill="white" />
        </clipPath>
    </defs>
</svg>
<svg
    *ngIf="name === 'brain'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <mask id="path-1-inside-1_11059_44131" fill="white">
        <path
            d="M9.875 22C8.88333 22 8.02778 21.6549 7.30833 20.9646C6.58889 20.2743 6.18056 19.4431 6.08333 18.4708C4.91667 18.3153 3.94444 17.8 3.16667 16.925C2.38889 16.05 2 15.0194 2 13.8333C2 13.425 2.05347 13.0215 2.16042 12.6229C2.26736 12.2243 2.42778 11.85 2.64167 11.5C2.42778 11.15 2.26736 10.7806 2.16042 10.3917C2.05347 10.0028 2 9.59444 2 9.16667C2 7.98056 2.38889 6.95486 3.16667 6.08958C3.94444 5.22431 4.90694 4.71389 6.05417 4.55833C6.1125 3.56667 6.51111 2.72569 7.25 2.03542C7.98889 1.34514 8.86389 1 9.875 1C10.3806 1 10.8521 1.09722 11.2896 1.29167C11.7271 1.48611 12.1306 1.74861 12.5 2.07917C12.85 1.74861 13.2486 1.48611 13.6958 1.29167C14.1431 1.09722 14.6194 1 15.125 1C16.1361 1 17.0062 1.34028 17.7354 2.02083C18.4646 2.70139 18.8583 3.5375 18.9167 4.52917C20.0639 4.68472 21.0312 5.2 21.8188 6.075C22.6063 6.95 23 7.98056 23 9.16667C23 9.59444 22.9465 10.0028 22.8396 10.3917C22.7326 10.7806 22.5722 11.15 22.3583 11.5C22.5722 11.85 22.7326 12.2243 22.8396 12.6229C22.9465 13.0215 23 13.425 23 13.8333C23 15.0389 22.6063 16.0743 21.8188 16.9396C21.0312 17.8049 20.0542 18.3153 18.8875 18.4708C18.7903 19.4431 18.3868 20.2743 17.6771 20.9646C16.9674 21.6549 16.1167 22 15.125 22C14.6389 22 14.1674 21.9076 13.7104 21.7229C13.2535 21.5382 12.85 21.2806 12.5 20.95C12.1306 21.2806 11.7222 21.5382 11.275 21.7229C10.8278 21.9076 10.3611 22 9.875 22ZM13.6667 4.79167V18.2083C13.6667 18.6167 13.8076 18.9618 14.0896 19.2437C14.3715 19.5257 14.7167 19.6667 15.125 19.6667C15.5139 19.6667 15.8493 19.5111 16.1312 19.2C16.4132 18.8889 16.5639 18.5389 16.5833 18.15C16.175 17.9944 15.8007 17.7854 15.4604 17.5229C15.1201 17.2604 14.8139 16.9444 14.5417 16.575C14.3472 16.3028 14.2743 16.0111 14.3229 15.7C14.3715 15.3889 14.5319 15.1361 14.8042 14.9417C15.0764 14.7472 15.3681 14.6743 15.6792 14.7229C15.9903 14.7715 16.2431 14.9319 16.4375 15.2042C16.6514 15.5153 16.9236 15.7535 17.2542 15.9187C17.5847 16.084 17.9444 16.1667 18.3333 16.1667C18.975 16.1667 19.5243 15.9382 19.9813 15.4812C20.4382 15.0243 20.6667 14.475 20.6667 13.8333C20.6667 13.7361 20.6618 13.6389 20.6521 13.5417C20.6424 13.4444 20.6181 13.3472 20.5792 13.25C20.2486 13.4444 19.8937 13.5903 19.5146 13.6875C19.1354 13.7847 18.7417 13.8333 18.3333 13.8333C18.0028 13.8333 17.7257 13.7215 17.5021 13.4979C17.2785 13.2743 17.1667 12.9972 17.1667 12.6667C17.1667 12.3361 17.2785 12.059 17.5021 11.8354C17.7257 11.6118 18.0028 11.5 18.3333 11.5C18.975 11.5 19.5243 11.2715 19.9813 10.8146C20.4382 10.3576 20.6667 9.80833 20.6667 9.16667C20.6667 8.525 20.4382 7.98056 19.9813 7.53333C19.5243 7.08611 18.975 6.85278 18.3333 6.83333C18.1194 7.18333 17.8424 7.48958 17.5021 7.75208C17.1618 8.01458 16.7875 8.22361 16.3792 8.37917C16.0681 8.49583 15.7667 8.48611 15.475 8.35C15.1833 8.21389 14.9889 7.99028 14.8917 7.67917C14.7944 7.36806 14.809 7.06667 14.9354 6.775C15.0618 6.48333 15.2806 6.28889 15.5917 6.19167C15.8833 6.09444 16.1215 5.91944 16.3062 5.66667C16.491 5.41389 16.5833 5.12222 16.5833 4.79167C16.5833 4.38333 16.4424 4.03819 16.1604 3.75625C15.8785 3.47431 15.5333 3.33333 15.125 3.33333C14.7167 3.33333 14.3715 3.47431 14.0896 3.75625C13.8076 4.03819 13.6667 4.38333 13.6667 4.79167ZM11.3333 18.2083V4.79167C11.3333 4.38333 11.1924 4.03819 10.9104 3.75625C10.6285 3.47431 10.2833 3.33333 9.875 3.33333C9.46667 3.33333 9.12153 3.47431 8.83958 3.75625C8.55764 4.03819 8.41667 4.38333 8.41667 4.79167C8.41667 5.10278 8.50417 5.38958 8.67917 5.65208C8.85417 5.91458 9.0875 6.09444 9.37917 6.19167C9.69028 6.28889 9.91389 6.48333 10.05 6.775C10.1861 7.06667 10.2056 7.36806 10.1083 7.67917C9.99167 7.99028 9.7875 8.21389 9.49583 8.35C9.20417 8.48611 8.90278 8.49583 8.59167 8.37917C8.18333 8.22361 7.80903 8.01458 7.46875 7.75208C7.12847 7.48958 6.85139 7.18333 6.6375 6.83333C6.01528 6.85278 5.47569 7.09097 5.01875 7.54792C4.56181 8.00486 4.33333 8.54444 4.33333 9.16667C4.33333 9.80833 4.56181 10.3576 5.01875 10.8146C5.47569 11.2715 6.025 11.5 6.66667 11.5C6.99722 11.5 7.27431 11.6118 7.49792 11.8354C7.72153 12.059 7.83333 12.3361 7.83333 12.6667C7.83333 12.9972 7.72153 13.2743 7.49792 13.4979C7.27431 13.7215 6.99722 13.8333 6.66667 13.8333C6.25833 13.8333 5.86458 13.7847 5.48542 13.6875C5.10625 13.5903 4.75139 13.4444 4.42083 13.25C4.38194 13.3472 4.35764 13.4444 4.34792 13.5417C4.33819 13.6389 4.33333 13.7361 4.33333 13.8333C4.33333 14.475 4.56181 15.0243 5.01875 15.4812C5.47569 15.9382 6.025 16.1667 6.66667 16.1667C7.05556 16.1667 7.41528 16.084 7.74583 15.9187C8.07639 15.7535 8.34861 15.5153 8.5625 15.2042C8.75694 14.9319 9.00972 14.7715 9.32083 14.7229C9.63194 14.6743 9.92361 14.7472 10.1958 14.9417C10.4681 15.1361 10.6285 15.3889 10.6771 15.7C10.7257 16.0111 10.6528 16.3028 10.4583 16.575C10.1861 16.9444 9.875 17.2653 9.525 17.5375C9.175 17.8097 8.79583 18.0236 8.3875 18.1792C8.40694 18.5681 8.5625 18.9132 8.85417 19.2146C9.14583 19.516 9.48611 19.6667 9.875 19.6667C10.2833 19.6667 10.6285 19.5257 10.9104 19.2437C11.1924 18.9618 11.3333 18.6167 11.3333 18.2083Z"
        />
    </mask>
    <path
        d="M9.875 22C8.88333 22 8.02778 21.6549 7.30833 20.9646C6.58889 20.2743 6.18056 19.4431 6.08333 18.4708C4.91667 18.3153 3.94444 17.8 3.16667 16.925C2.38889 16.05 2 15.0194 2 13.8333C2 13.425 2.05347 13.0215 2.16042 12.6229C2.26736 12.2243 2.42778 11.85 2.64167 11.5C2.42778 11.15 2.26736 10.7806 2.16042 10.3917C2.05347 10.0028 2 9.59444 2 9.16667C2 7.98056 2.38889 6.95486 3.16667 6.08958C3.94444 5.22431 4.90694 4.71389 6.05417 4.55833C6.1125 3.56667 6.51111 2.72569 7.25 2.03542C7.98889 1.34514 8.86389 1 9.875 1C10.3806 1 10.8521 1.09722 11.2896 1.29167C11.7271 1.48611 12.1306 1.74861 12.5 2.07917C12.85 1.74861 13.2486 1.48611 13.6958 1.29167C14.1431 1.09722 14.6194 1 15.125 1C16.1361 1 17.0062 1.34028 17.7354 2.02083C18.4646 2.70139 18.8583 3.5375 18.9167 4.52917C20.0639 4.68472 21.0312 5.2 21.8188 6.075C22.6063 6.95 23 7.98056 23 9.16667C23 9.59444 22.9465 10.0028 22.8396 10.3917C22.7326 10.7806 22.5722 11.15 22.3583 11.5C22.5722 11.85 22.7326 12.2243 22.8396 12.6229C22.9465 13.0215 23 13.425 23 13.8333C23 15.0389 22.6063 16.0743 21.8188 16.9396C21.0312 17.8049 20.0542 18.3153 18.8875 18.4708C18.7903 19.4431 18.3868 20.2743 17.6771 20.9646C16.9674 21.6549 16.1167 22 15.125 22C14.6389 22 14.1674 21.9076 13.7104 21.7229C13.2535 21.5382 12.85 21.2806 12.5 20.95C12.1306 21.2806 11.7222 21.5382 11.275 21.7229C10.8278 21.9076 10.3611 22 9.875 22ZM13.6667 4.79167V18.2083C13.6667 18.6167 13.8076 18.9618 14.0896 19.2437C14.3715 19.5257 14.7167 19.6667 15.125 19.6667C15.5139 19.6667 15.8493 19.5111 16.1312 19.2C16.4132 18.8889 16.5639 18.5389 16.5833 18.15C16.175 17.9944 15.8007 17.7854 15.4604 17.5229C15.1201 17.2604 14.8139 16.9444 14.5417 16.575C14.3472 16.3028 14.2743 16.0111 14.3229 15.7C14.3715 15.3889 14.5319 15.1361 14.8042 14.9417C15.0764 14.7472 15.3681 14.6743 15.6792 14.7229C15.9903 14.7715 16.2431 14.9319 16.4375 15.2042C16.6514 15.5153 16.9236 15.7535 17.2542 15.9187C17.5847 16.084 17.9444 16.1667 18.3333 16.1667C18.975 16.1667 19.5243 15.9382 19.9813 15.4812C20.4382 15.0243 20.6667 14.475 20.6667 13.8333C20.6667 13.7361 20.6618 13.6389 20.6521 13.5417C20.6424 13.4444 20.6181 13.3472 20.5792 13.25C20.2486 13.4444 19.8937 13.5903 19.5146 13.6875C19.1354 13.7847 18.7417 13.8333 18.3333 13.8333C18.0028 13.8333 17.7257 13.7215 17.5021 13.4979C17.2785 13.2743 17.1667 12.9972 17.1667 12.6667C17.1667 12.3361 17.2785 12.059 17.5021 11.8354C17.7257 11.6118 18.0028 11.5 18.3333 11.5C18.975 11.5 19.5243 11.2715 19.9813 10.8146C20.4382 10.3576 20.6667 9.80833 20.6667 9.16667C20.6667 8.525 20.4382 7.98056 19.9813 7.53333C19.5243 7.08611 18.975 6.85278 18.3333 6.83333C18.1194 7.18333 17.8424 7.48958 17.5021 7.75208C17.1618 8.01458 16.7875 8.22361 16.3792 8.37917C16.0681 8.49583 15.7667 8.48611 15.475 8.35C15.1833 8.21389 14.9889 7.99028 14.8917 7.67917C14.7944 7.36806 14.809 7.06667 14.9354 6.775C15.0618 6.48333 15.2806 6.28889 15.5917 6.19167C15.8833 6.09444 16.1215 5.91944 16.3062 5.66667C16.491 5.41389 16.5833 5.12222 16.5833 4.79167C16.5833 4.38333 16.4424 4.03819 16.1604 3.75625C15.8785 3.47431 15.5333 3.33333 15.125 3.33333C14.7167 3.33333 14.3715 3.47431 14.0896 3.75625C13.8076 4.03819 13.6667 4.38333 13.6667 4.79167ZM11.3333 18.2083V4.79167C11.3333 4.38333 11.1924 4.03819 10.9104 3.75625C10.6285 3.47431 10.2833 3.33333 9.875 3.33333C9.46667 3.33333 9.12153 3.47431 8.83958 3.75625C8.55764 4.03819 8.41667 4.38333 8.41667 4.79167C8.41667 5.10278 8.50417 5.38958 8.67917 5.65208C8.85417 5.91458 9.0875 6.09444 9.37917 6.19167C9.69028 6.28889 9.91389 6.48333 10.05 6.775C10.1861 7.06667 10.2056 7.36806 10.1083 7.67917C9.99167 7.99028 9.7875 8.21389 9.49583 8.35C9.20417 8.48611 8.90278 8.49583 8.59167 8.37917C8.18333 8.22361 7.80903 8.01458 7.46875 7.75208C7.12847 7.48958 6.85139 7.18333 6.6375 6.83333C6.01528 6.85278 5.47569 7.09097 5.01875 7.54792C4.56181 8.00486 4.33333 8.54444 4.33333 9.16667C4.33333 9.80833 4.56181 10.3576 5.01875 10.8146C5.47569 11.2715 6.025 11.5 6.66667 11.5C6.99722 11.5 7.27431 11.6118 7.49792 11.8354C7.72153 12.059 7.83333 12.3361 7.83333 12.6667C7.83333 12.9972 7.72153 13.2743 7.49792 13.4979C7.27431 13.7215 6.99722 13.8333 6.66667 13.8333C6.25833 13.8333 5.86458 13.7847 5.48542 13.6875C5.10625 13.5903 4.75139 13.4444 4.42083 13.25C4.38194 13.3472 4.35764 13.4444 4.34792 13.5417C4.33819 13.6389 4.33333 13.7361 4.33333 13.8333C4.33333 14.475 4.56181 15.0243 5.01875 15.4812C5.47569 15.9382 6.025 16.1667 6.66667 16.1667C7.05556 16.1667 7.41528 16.084 7.74583 15.9187C8.07639 15.7535 8.34861 15.5153 8.5625 15.2042C8.75694 14.9319 9.00972 14.7715 9.32083 14.7229C9.63194 14.6743 9.92361 14.7472 10.1958 14.9417C10.4681 15.1361 10.6285 15.3889 10.6771 15.7C10.7257 16.0111 10.6528 16.3028 10.4583 16.575C10.1861 16.9444 9.875 17.2653 9.525 17.5375C9.175 17.8097 8.79583 18.0236 8.3875 18.1792C8.40694 18.5681 8.5625 18.9132 8.85417 19.2146C9.14583 19.516 9.48611 19.6667 9.875 19.6667C10.2833 19.6667 10.6285 19.5257 10.9104 19.2437C11.1924 18.9618 11.3333 18.6167 11.3333 18.2083Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="3"
        mask="url(#path-1-inside-1_11059_44131)"
    />
</svg>
<svg
    *ngIf="name === 'folder'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
        stroke="#000D4D"
        stroke-opacity="0.45"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'add'"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
>
    <path
        d="M9.99935 4.68945V16.3561M4.16602 10.5228H15.8327"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'info'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'check'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M20 6L9 17L4 12"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'check_circle' || name === 'check-circle'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M17 9L10.125 16L7 12.8182M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#067A57"
        stroke-opacity="0.8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'send'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M18.3337 1.66675L9.16699 10.8334M18.3337 1.66675L12.5003 18.3334L9.16699 10.8334M18.3337 1.66675L1.66699 7.50008L9.16699 10.8334"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'paperclip'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M21.4403 11.0489L12.2503 20.2389C11.1244 21.3648 9.59747 21.9973 8.00529 21.9973C6.41311 21.9973 4.88613 21.3648 3.76029 20.2389C2.63445 19.1131 2.00195 17.5861 2.00195 15.9939C2.00195 14.4018 2.63445 12.8748 3.76029 11.7489L12.9503 2.55894C13.7009 1.80838 14.7188 1.38672 15.7803 1.38672C16.8417 1.38672 17.8597 1.80838 18.6103 2.55894C19.3609 3.30951 19.7825 4.32749 19.7825 5.38894C19.7825 6.4504 19.3609 7.46838 18.6103 8.21894L9.41029 17.4089C9.03501 17.7842 8.52602 17.9951 7.99529 17.9951C7.46456 17.9951 6.95557 17.7842 6.58029 17.4089C6.20501 17.0337 5.99418 16.5247 5.99418 15.9939C5.99418 15.4632 6.20501 14.9542 6.58029 14.5789L15.0703 6.09894"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<svg
    *ngIf="name === 'external_link'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
>
    <path
        d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
<div class="counter" *ngIf="counter">{{ counter }}</div>
